import './polyfills';

import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';

import React from 'react';
import { createRoot } from 'react-dom/client';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import App from './containers/App';
import './modules/I18n';
import Config from './config';
import * as serviceWorker from './serviceWorker';

const AG_GRID_LICENSE =
  'Using_this_{AG_Grid}_Enterprise_key_{AG-093429}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Future_Capital}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Future_Capital}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Future_Capital}_need_to_be_licensed___{Future_Capital}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{20_September_2026}____[v3]_[01]_MTc4OTg1ODgwMDAwMA==294e1246cdd4b2b45e17a480d5c3726d';

/* AG Grid module registery. We are importing all here, we may want to trim this down to what we are actually using at some point.
 */
ModuleRegistry.registerModules([AllEnterpriseModule]);
LicenseManager.setLicenseKey(AG_GRID_LICENSE);
LogRocket.init(Config.analytics.logrocket.apiKey);
setupLogRocketReact(LogRocket);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// Service worker - unregister for now in Vite
// Vite handles service workers differently than CRA
// If you need service workers, consider using vite-plugin-pwa
serviceWorker.unregister();
